import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Header from './Header.vue';
import Sidebar from './sidebar.vue';
import Manage_bar from './manage-bar.vue';
import Index from './index.vue';
import Bookmarkedlogos from './bookmarked-logos.vue';
import Getlogofiles from './get-logo-files.vue';
import Logofiles from './logo-files.vue';
import Getprofilesandcovers from './get-profiles-and-covers.vue';
import Profilesandcovers from './profiles-and-covers.vue';
import Exclusivedeals from './exclusive-deals.vue';
import Businesscards from './business-cards.vue';
import Createbusinesscard from './create-business-card.vue';
import Editbusinesscard from './edit-business-card.vue';
import Emailsignatures from './email-signatures.vue';
import Createemailsignature from './create-email-signature.vue';
import Editemailsignature from './edit-email-signature.vue';
import Setupemailsignature from './set-up-email-signature.vue';
import Linkinbio from './link-in-bio.vue';
import Createlinkinbio from './create-link-in-bio.vue';
import Editlinkinbio from './edit-link-in-bio.vue';
import Account_tabs from './account-tabs.vue';
import Account from './account.vue';
import Billing from './billing.vue';
import Edit_billing from './edit-billing.vue';
import Cancel_reasons from './cancel-reasons.vue';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies';
//issues with async await methods
import 'regenerator-runtime/runtime';

Vue.config.devtools = true;
Vue.use(VueRouter);
Vue.use(VueCookies);

const routes = [
  { name: 'index' ,path: '/dashboard/', component: Index },
  { name: 'index' ,path: '/dashboard/index', component: Index },
  { name: 'bookmarked-logos' ,path: '/dashboard/bookmarked-logos', component: Bookmarkedlogos },
  { name: 'get-logo-files' ,path: '/dashboard/get-logo-files', component: Getlogofiles },
  { name: 'logo-files' ,path: '/dashboard/logo-files/:logo_unique_id', component: Logofiles },
  { name: 'get-profiles-and-covers' ,path: '/dashboard/get-profiles-and-covers', component: Getprofilesandcovers },
  { name: 'profiles-and-covers' ,path: '/dashboard/profiles-and-covers/:logo_unique_id', component: Profilesandcovers },
  { name: 'exclusive-deals' ,path: '/dashboard/exclusive-deals', component: Exclusivedeals },
  { name: 'business-cards' ,path: '/dashboard/business-cards', component: Businesscards },
  { name: 'create-business-card' ,path: '/dashboard/create-business-card', component: Createbusinesscard },
  { name: 'edit-business-card' ,path: '/dashboard/edit-business-card/:business_card_id', component: Editbusinesscard },
  { name: 'email-signatures' ,path: '/dashboard/email-signatures', component: Emailsignatures },
  { name: 'create-email-signature' ,path: '/dashboard/create-email-signature', component: Createemailsignature },
  { name: 'edit-email-signature' ,path: '/dashboard/edit-email-signature/:email_signature_id', component: Editemailsignature },
  { name: 'set-up-email-signature' ,path: '/dashboard/set-up-email-signature/:email_signature_id', component: Setupemailsignature },
  { name: 'link-in-bio' ,path: '/dashboard/link-in-bio', component: Linkinbio },
  { name: 'create-link-in-bio' ,path: '/dashboard/create-link-in-bio', component: Createlinkinbio },
  { name: 'edit-link-in-bio' ,path: '/dashboard/edit-link-in-bio/:link_in_bio_id', component: Editlinkinbio },
  { name: 'account' ,path: '/dashboard/account', component: Account },
  { name: 'billing' ,path: '/dashboard/billing', component: Billing },
  { name: 'edit-billing' ,path: '/dashboard/edit-billing', component: Edit_billing },
  { name: 'cancel-reasons' ,path: '/dashboard/cancel-reasons', component: Cancel_reasons },
];

const router = new VueRouter({
  scrollBehavior() {
  return { x: 0, y: 0 };
},
routes,
mode: 'history'
});

Vue.component('app-header', Header);
Vue.component('sidebar-header', Sidebar);
Vue.component('manage-bar', Manage_bar);
Vue.component('account-header', Account_tabs);
Vue.component('vue-headful', VueHeadful);

var vm  = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js